import CheckIcon from "@/assets/icons/check-circle.svg"
import CloseIcon from "@/assets/icons/close.svg"

interface Props {
  open: boolean
  onClose: () => void
}

export function ThankYouAlert(props: Props) {
  const { open, onClose } = props

  if (!open) return null

  return (
    <div className="absolute top-4 left-1/2 z-[1] transform -translate-x-1/2 w-[calc(100%-2rem)] flex items-center justify-between py-4 px-5 bg-[#1f1f1f] rounded-xl border border-[#414141] shadow-lg">
      <div className="flex items-center gap-2">
        <CheckIcon className="w-6 h-6 fill-[#147546]" />
        <span className="text-[#ffffff] text-[17px] font-[400]">Спасибо за обратную связь</span>
      </div>
      <button onClick={onClose}>
        <CloseIcon className="w-6 h-6 fill-[#959596]" />
      </button>
    </div>
  )
}
